import baseRequest from "../_core/baseRequest";

export default {
    getHeatMap: params => {
        return baseRequest.post(`/heatmap/total`, params);
    }
};
